module.exports = __webpack_public_path__ + "img/标题背景.f24e0b3c.png";